import { createTheme } from "@mui/material/styles";

const brand = "#800b33";
const brandHover = "#6c0a2b";

const theme = createTheme({
  palette: {
    primary: { main: brand, dark: brandHover, contrastText: "#fff" },
    background: { default: "#fafafa", paper: "#ffffff" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: `"Inter", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif`,
    h5: { fontWeight: 800 },
    h6: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    MuiCard: { styleOverrides: { root: { boxShadow: "0 6px 20px rgba(0,0,0,.06)" } } },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
        containedPrimary: { "&:hover": { background: brandHover } },
      },
    },
  },
});

export default theme;
export { brand, brandHover };
